import { TODO } from '@b2b/types/core';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsDetailOverviewControllerModule } from './controllers/ProgramsDetailOverviewController';

export const ProgramsDetailOverviewView = angular
  .module('acme.view.application.programs.detail.overview', [
    uiRouter,
    'ui.bootstrap',
    ProgramsDetailOverviewControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.programsDetail.overview',
      url: '/overview',
      views: {
        'subview-main': {
          controller: 'ProgramsDetailOverviewController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/detail/overview/overview.tpl.html',
        },
      },
      data: {
        pageTitle: 'Event Template',
      },
      resolve: {
        ResolveViewData: [
          'ResolveViewData',
          function (ResolveViewData: TODO) {
            return ResolveViewData;
          },
        ],
      },
    });
  }).name;
